import React from 'react';
import { BarChart2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();
  
  return (
    <footer className="bg-bg-primary py-12" role="contentinfo">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0">
            <p className="text-text-secondary">
              {t('footer.copyright', { year: currentYear })}
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row items-center">
            <nav className="flex space-x-6 mb-6 md:mb-0 md:mr-10" aria-label="Legal">
              <Link 
                to="/terms" 
                className="text-text-secondary hover:text-gradient-from transition-colors"
              >
                {t('nav.terms')}
              </Link>
              <Link 
                to="/privacy" 
                className="text-text-secondary hover:text-gradient-from transition-colors"
              >
                {t('nav.privacy')}
              </Link>
            </nav>
            
            <div className="flex space-x-6">
              <a 
                href="#" 
                aria-label={t('nav.results')}
                className="text-text-secondary hover:text-gradient-from transition-colors"
              >
                <BarChart2 size={20} aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;